import { useEffect } from 'react'

import { useAppSelector } from '@user/store/hooks'
import { selectAllTechs } from '@user/store/techs'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts'
import { selectAllServiceLocations } from '@user/store/entityLocations'

import {
  useSchedulingWizard,
  initApptActionCreator as initAppt,
} from '../../wizardContext'

export function useInitAppt() {
  const [{ appointment }, dispatch] = useSchedulingWizard()
  const techs = useAppSelector(selectAllTechs)
  const services = useAppSelector(selectAllLeadOppProducts)
  const locations = useAppSelector(selectAllServiceLocations)

  useEffect(() => {
    if (appointment) {
      dispatch(
        initAppt({
          techs,
          services,
          locations,
        }),
      )
    }
  }, [appointment, dispatch, locations, services, techs])
}
